// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3iAZT","header":"MessagesList_header__1U9Db","chat":"MessagesList_chat__3w2cN"};